export const ru = {
    placeholder_text: 'Выберите значение',
    empty_text: 'Пока ничего не добавлено',
};
